import React from "react";
import { ComputedContextFrame } from "../../model/context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faToggleOff,
    faToggleOn
} from "@fortawesome/free-solid-svg-icons";

export function TonalityHighlightToggle({
    contextFrame,
    tonalityHighlightVisible,
    setTonalityHighlightVisible
} : {
    contextFrame?: ComputedContextFrame,
    tonalityHighlightVisible: boolean,
    setTonalityHighlightVisible: (visible: boolean) => void
}){

    const style = tonalityHighlightVisible ? { backgroundColor: 'var(--ryd-color-primary)' } : {};

    return ( <button
        onClick={() => setTonalityHighlightVisible(!tonalityHighlightVisible)}
        disabled={!contextFrame?.tonality}>
            Tonality visibility
            <FontAwesomeIcon icon={tonalityHighlightVisible ? faToggleOn : faToggleOff} />
        </button> );
}